import { PageChrome } from '@/components/gg/chrome'
import { Library } from '@/pages/Library'

/**
 * Library (/app/library). Root tab. Brian's after/library.html v2.1: each
 * story moves on as it's done, To record → Recorded → Posted (a light record
 * that clears itself 90 days after I posted it), plus Newsletter.
 */
export function LibraryPage() {
  return (
    <>
      <PageChrome title="Library" navKey="library" />
      <Library />
    </>
  )
}
